// Redes sociais do rodapé. Só entram as que têm endereço: um ícone sem link leva a
// lugar nenhum. Para mostrar as outras (Facebook, Pinterest, YouTube),
// acrescente o endereço do perfil da loja em cada uma.
export interface SocialLink {
  label: string;
  icon: string;
  url: string;
}

export const socialLinks: SocialLink[] = [
  { label: "Instagram", icon: "ri-instagram-line", url: "https://www.instagram.com/bozzettistore/" },
  { label: "TikTok", icon: "ri-tiktok-line", url: "https://www.tiktok.com/@bozzetti.store" },
  // { label: "Facebook", icon: "ri-facebook-circle-line", url: "" },
  // { label: "Pinterest", icon: "ri-pinterest-line", url: "" },
  // { label: "YouTube", icon: "ri-youtube-line", url: "" },
];
